/**
 * Site / 현장·기기 등록 UI — `site:*` i18n 키 기반 ErrorMessage
 */

import {
  getBackendI18nKeyFromResponse,
  getHttpStatus,
  getServerMessage,
  isNetworkError,
  looksLikeI18nKey,
  normalizeBackendI18nKey,
} from './apiError';
import type { ErrorMessage } from './types';

const SITE_ERRORS = {
  GENERIC: {
    title: 'site:deviceRegistrationFailed',
    message: 'site:deviceRegistrationFailed',
    type: 'error' as const,
  },
} as const;

export function parseSiteApiError(error: unknown): ErrorMessage {
  if (!error) {
    return SITE_ERRORS.GENERIC;
  }

  if (isNetworkError(error)) {
    return {
      title: 'auth:network_error',
      message: 'auth:network_error_message',
      type: 'error',
    };
  }

  const fromBackend = getBackendI18nKeyFromResponse(error);
  if (fromBackend && looksLikeI18nKey(fromBackend)) {
    return {
      title: 'site:deviceRegistrationFailed',
      message: normalizeBackendI18nKey(fromBackend),
      type: 'error',
    };
  }

  const rawMsg = getServerMessage(error);
  if (rawMsg && looksLikeI18nKey(rawMsg)) {
    return {
      title: 'site:deviceRegistrationFailed',
      message: normalizeBackendI18nKey(rawMsg),
      type: 'error',
    };
  }

  switch (getHttpStatus(error)) {
    case 403:
      return {
        title: 'site:deviceRegistrationFailed',
        message: 'site:deviceRegistrationFailed',
        type: 'error',
      };
    case 404:
      return {
        title: 'site:deviceRegistrationFailed',
        message: 'site:deviceInfoMissing',
        type: 'error',
      };
    case 409:
      return {
        title: 'site:deviceRegistrationFailed',
        message: 'site:deviceRegistrationFailed',
        type: 'error',
      };
    case 500:
      return {
        title: 'site:deviceRegistrationFailed',
        message: 'site:deviceRegistrationFailed',
        type: 'error',
      };
    default:
      return SITE_ERRORS.GENERIC;
  }
}
